import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Header, Body, Content } from 'components/Modal';
import { CustomText } from 'components/CustomText';
import { Container } from './NoParcelModal.styles';

const NoParcelsModal = ({ message }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Header>{t('NO_INFORMATION_AVAILABLE')}</Header>
      <Body>
        <Content>
          <CustomText as="span" text={message} />
        </Content>
      </Body>
    </Container>
  );
};

NoParcelsModal.propTypes = {
  message: PropTypes.string.isRequired,
};

export default NoParcelsModal;
